<template>
  <div id="home">
  <div class="text">
    <h1>{{header}}</h1>
      Welcome to dylancallaghan.co.za, the online profile for me, Dylan Callaghan.
  </div>
    Here are some useful links:
    <project title="GitHub Profile"
    link="https://github.com/DCallaz"
    blurb="My GitHub profile, where all my projects are stored."/>
    <project title="LinkedIn page"
    link="https://www.linkedin.com/in/dylan-callaghan/"
    blurb="My LinkedIn profile, containing all the information on my
    professional carrer."/>
  </div>
</template>

<script>
import project from './project'
export default {
  name: 'home',
  data () {
    return {
      header_num: 0,
      header: ' ',
      lock: true
    }
  },
  computed: {
    header_hid: function () {
      var elems = ['Developer', 'Programmer', 'Researcher']
      return elems[this.header_num]
    }
  },
  mounted: function () {
    this.type()
    setInterval(this.type, 5000)
  },
  methods: {
    type: function () {
      if (this.lock === true) {
        this.lock = false
        if (this.header_num < 2) {
          this.header_num++
        } else {
          this.header_num = 0
        }
        this.type_iter_down()
      }
    },
    type_iter_down: function () {
      if (this.header.length !== 1) {
        this.header = this.header.substring(0, this.header.length - 1)
        setTimeout(this.type_iter_down, 100)
      } else {
        this.type_iter_up()
      }
    },
    type_iter_up: function () {
      if (this.header.length !== this.header_hid.length) {
        this.header = this.header_hid.substring(0, this.header.length + 1)
        setTimeout(this.type_iter_up, 100)
      } else {
        this.lock = true
      }
    }
  },
  components: {
    project
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue